import get from 'lodash/get'
import { ANALYTICS_EVENTS } from '../utils'

export const getAnalyticsTrackingHandler = ({ events }) => {
  const {
    ANALYTICS_MODULE_VISITED
  } = ANALYTICS_EVENTS

  return {
    visitedModule: (data) => {
      const indicator = get(data, 'indicator')
      events.track(ANALYTICS_MODULE_VISITED, {
        section: indicator.replaceAll('-', '_')
      })
    }
  }
}
